/* eslint-disable @typescript-eslint/ban-types */
import { FormControlLabel, Switch } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { SingleFieldProps } from '../../../../Types'
import { useStyles } from './Style'
import { getValue } from './Utils'

const ToggleField = <T extends {}>({ field, input }: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyles()
  const [switchValue, setswitchValue] = useState(false)

  const onSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    input.onChange(event.target.checked)
    if (field.changeEvent) {
      field.changeEvent(event.target.checked ? 'true' : 'false')
    }
  }

  useEffect(() => {
    setswitchValue(getValue(input))
  }, [input])

  return (
    <>
      <FormControlLabel
        control={<Switch onChange={onSwitchChange} checked={switchValue} />}
        label={field.label}
        className={classes.toggle}
      />
    </>
  )
}

export default ToggleField
